import { lazy } from 'react';

const DocumentRoutes = [
  {
    path: 'document-requirements',
    component: lazy(() => import('../../views/document-requirements')),
  },
  {
    path: 'document-requirements/create',
    component: lazy(
      () =>
        import('../../views/document-requirements/document-requirement-add'),
    ),
  },
  {
    path: 'document-requirements/:id/edit',
    component: lazy(
      () =>
        import('../../views/document-requirements/document-requirement-edit'),
    ),
  },
];

export default DocumentRoutes;
